import { render, staticRenderFns } from "./PickUpNumDlg.vue?vue&type=template&id=52f2fa6c&scoped=true"
import script from "./PickUpNumDlg.vue?vue&type=script&lang=js"
export * from "./PickUpNumDlg.vue?vue&type=script&lang=js"
import style0 from "./PickUpNumDlg.vue?vue&type=style&index=0&id=52f2fa6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f2fa6c",
  null
  
)

export default component.exports